export default {
  pagination: {},
  student: null,
  students: []
};
